module.exports = __webpack_public_path__ + "img/ment_report_back.72b1ed27.png";